import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { IcLoad40Icon, IcLoadIcon } from '@gem/icons';

import { useFileUploadStatePresenter } from 'APP/hooks/useFileUploadState/useFileUploadState';
import { InfiniteUploadIcon } from 'APP/main/components/InfiniteUploadIcon/InfiniteUploadIcon';
import { ProgressLoadIcon } from 'APP/main/components/ProgressLoadIcon/ProgressLoadIcon';

import { IconSize } from './UploaderState.types';

interface IUploaderStateProps {
  size?: IconSize;
  className?: string;
  uploadFileData: {
    uploadProgress: number | null;
    cancelUpload(): Promise<void>;
    hasError?: boolean;
  };
}

export const ICON = {
  [IconSize.Normal]: IcLoadIcon,
  [IconSize.Big]: IcLoad40Icon,
};

export const UploaderState: FC<PropsWithChildren<IUploaderStateProps>> = observer((props) => {
  const { uploadFileData, className, children, size = IconSize.Normal } = props;

  const presenter = useFileUploadStatePresenter(uploadFileData);

  if ((presenter.uploadProgress === null && !children) || uploadFileData.hasError) {
    return null;
  }

  const Icon = ICON[size] || IcLoadIcon;

  return (
    <div className={className}>
      {presenter.isWaitingUploadProcess && (
        <InfiniteUploadIcon
          Icon={Icon}
          onClick={presenter.cancelUpload}
        />
      )}
      {presenter.isUploadProcess && (
        <ProgressLoadIcon
          Icon={Icon}
          progress={presenter.uploadProgress || 0}
          onClick={presenter.cancelUpload}
        />
      )}
      {presenter.uploadProgress === null && children}
    </div>
  );
});
